export default {
  title: {
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal Advice',
    privacy: 'Privacy Policy',
    cookies: 'Privacy Policy',
    construction: 'Under construction',
    error404: 'Not found'
  },
  message: {
    generic: {
      loadingData: 'Loading data',
      moreInfo: 'More info',
      error: {
        notFound1: "Oops! You're lost.",
        notFound2: 'The page you are looking for was not found.'
      },
      webConstruction: 'Page under construction'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      legalWarning: 'Legal warning',
      privacyPolicy: 'Privacy policy',
      cookiesPolicy: 'Cookies policy'
    }
  },
  error: {
    undefined: 'Oops! Something went wrong!',
    notFound: "This page doesn't exist."
  }
};
